import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class GuestIdentityImageRepositoryService extends BaseRepositoryService<
  ModelRegistry['guest-identity-image']
> {
  recordName = 'guest-identity-image';
  implementMethods = ['query'];

  public getRecords(id: string) {
    return super.query(
      {
        guest_identity_verification_id: id,
      },
      {
        adapterOptions: {
          reload: true,
        },
      },
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/guest-identity-image': GuestIdentityImageRepositoryService;
  }
}
